import mapFunction from './mapResources';

export default mapFunction('category_material_items', {
    isFetching: false,
    items: []
});
